import {
    PRODUCT_DETAIL_REQUEST,
    PRODUCT_DETAIL_SUCCESS,
    PRODUCT_DETAIL_FAILURE,
    ADD_PRODUCT_DETAIL_REQUEST,
    ADD_PRODUCT_DETAIL_SUCCESS,
    ADD_PRODUCT_DETAIL_FAILURE,
    PRODUCT_ADDITIONAL_INFO_SUCCESS
} from "../constants/ActionTypes";
// import { bindActionCreators } from "redux";

const initialState = {
    loading: false,
    additionalInfoLoading: false,
    productDetail : [],
    productVariants : [],
    productImages : [],
    completeTheLook : [],
    similarProducts: [],
    additionalInfo: [],
    variants:[],
    error: null,
    tab_enabled_flag: '',
};

export default function productDetailReducer(state = initialState, action) {
    switch (action.type) {
        case PRODUCT_DETAIL_REQUEST:
            return {
                ...state,
                loading: true,
            };
        case PRODUCT_DETAIL_SUCCESS:
            return {
                ...state,
                // always replacing data
                // data: action.data,
                productDetail : action.data.product_detail,
                productVariants : action.data.variants,
                productImages : action.data.product_images,
                completeTheLook : action.data.complete_the_look_product,
                similarProducts: action.data.similar_product,
                variants: action.data.variant_color_details,
                tab_enabled_flag: action.data.tab_enabled_flag,
                pshop_soh_display : action.data.pshop_soh_display,
                loading: false,
                // if adding data
                // data: [...state.data, action.data]
            };
        case PRODUCT_ADDITIONAL_INFO_SUCCESS:
            return {
                ...state,
                additionalInfo: action.info.product_additional_info,
                loading: false,
            }
        case PRODUCT_DETAIL_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.error,
            };
            case ADD_PRODUCT_DETAIL_REQUEST:
                return {
                    ...state,
                    loading: false,
                    additionalInfoLoading: true,
                };
            case ADD_PRODUCT_DETAIL_SUCCESS:
                return {
                    ...state,
                    // always replacing data
                    // data: action.data,
                    
                    completeTheLook : action.data.complete_the_look_product,
                    similarProducts: action.data.similar_product,
                    productOffers: action.data.product_offers,
                additionalInfoLoading: false,

                   
                    // if adding data
                    // data: [...state.data, action.data]
                };
                case ADD_PRODUCT_DETAIL_FAILURE:
            return {
                ...state,
                additionalInfoLoading: false,
                error: action.error,
            };
        default:
            return state;
    }
}